




































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import EventLogsDropdown from '@/components/Admin/Lists/EventLogsDropdown.vue';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import { LocalizationHelpers } from '@/ts/helpers/LocalizationHelpers';
import Animation from '@/components/Common/Animations/Animation.vue';
import Badge from '@/components/Badges/Badge.vue';

@Component({
    components: {
        EventLogsDropdown,
        BaseDropDown,
        Animation,
        Badge,
    },
    methods: {
        ...mapActions({
            logOut: Actions.LOG_OUT,
        }),
    },
    computed: {
        ...mapGetters({
            currentUser: 'User/getUser',
            userIsLoggedIn: 'User/userIsLoggedIn',
            role: 'User/getUserMainRole',
            unseenCount: 'EventLogs/getUnseenCount',
            allLanguages: 'Localization/getAllLanguages',
        }),
    },
})
export default class TopBar extends Mixins(LocalizationMethods, DeviceMethods) {
    public profileDropdown: boolean = false;
    public notificationDropdown: boolean = false;
    public showLanguageDropDown: boolean = false;
    public unsubscribeMutationListener: any = null;

    constructor() {
        super();
    }

    get userData() {
        return this.$store.getters['User/getUser'];
    }

    get userFullName() {
        const user = this.userData;
        return user ? `${user.firstName} ${user.familyName}` : '';
    }

    get userRole() {
        let mainRole = this.$store.getters['User/getUserMainRole'];

        mainRole = typeof mainRole !== 'undefined' && mainRole !== null && mainRole !== ''
            ? mainRole.replace('-', ' ')
            : '';

        return mainRole;
    }

    get unreadMessageCount(): number {
        return this.$store.getters['Messages/unreadMessageCount'];
    }

    get notificationAnimationRef(): Vue & { triggerAnimation: () => void } {
        return this.$refs.notificationAnimationRef as Vue & { triggerAnimation: () => void };
    }

    get messagesAnimationRef(): Vue & { triggerAnimation: () => void } {
        return this.$refs.messagesAnimationRef as Vue & { triggerAnimation: () => void };
    }

    @Watch('unreadMessageCount')
    public unreadMessageCountChanged(newValue: number, oldValue: number) {
        if (newValue > oldValue) {
            if (this.$refs.messagesAnimationRef) {
                this.messagesAnimationRef.triggerAnimation();
            }
        }
    }

    public userHasAccessTo(feature: string) {
        if (this.$store.getters['User/getUser'] === null) {
            return false;
        }

        return this.$store.getters['User/getUser'].hasAccessTo(feature);
    }

    public changeLanguage(lang: string) {
        this.showLanguageDropDown = false;

        LocalizationHelpers.changePackagesLanguage(lang);

        this.$store.dispatch(Actions.GLOBAL_CHANGE_LANGUAGE, { vue: this, lang });
        this.$store.commit(Mutations.SET_LOCALIZATION_KEY, lang);
    }

    public toggleProfileDropdown() {
        this.notificationDropdown = false;
        this.profileDropdown = !this.profileDropdown;
    }

    public toggleNotificationDropdown() {
        this.profileDropdown = false;
        this.notificationDropdown = !this.notificationDropdown;
    }

    public closeDropDown(event: any) {
        if (!this.$el.contains(event.target)) {
            this.profileDropdown      = false;
            this.notificationDropdown = false;
        }
    }

    public created() {
      
        this.$store.dispatch(Actions.INITIALIZE_EVENT_LOG_SOCKET, this);

        window.addEventListener('click', this.closeDropDown);

        // Subscription on vuex store for new notifications
        this.unsubscribeMutationListener = this.$store.subscribe((mutation, state) => {
            if (mutation.type === Mutations.UPDATE_EVENT_LOGS) {
                if (this.$refs.notificationAnimationRef) {
                    this.notificationAnimationRef.triggerAnimation();
                }
            }
        });
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
        this.unsubscribeMutationListener();
    }

    public beforeCreate() {
        this.$store.dispatch(Actions.FETCH_ALL_LANGUAGES);
    }
}
